import React from 'react';
import PropTypes from 'prop-types';

Header.propTypes = {
  supportQuestion: PropTypes.object.isRequired
};

export default function Header(props) {
  const { supportQuestion } = props;

  return (
    <div className="space-y-1">
      <h5 className="text-3xl text-cs-gray-900 font-semibold">
        {supportQuestion.data.question}
      </h5>
    </div>
  );
};
